import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Redirects to login page if the user is not logged in.
// Change the login check / redirect target here to update it everywhere.
const useAuthGuard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("login") !== "true") {
      navigate("/");
    }
  }, []);
};

export default useAuthGuard;
